export default __webpack_public_path__ + "static/brandon-bold-68ff126af2189fbcf5eb1830c5beacf4.woff2";